import React, { useState } from 'react';

import MARKETBASE_THEME from '@dashboard/contexts/ThemeManager/theme';
import { EditOutlined } from '@mui/icons-material';
import { alpha, Box, Button, ClickAwayListener, TextField, Tooltip, Typography } from '@mui/material';

type Props = {
  initialValue: string;
  loading: boolean;
  onSave: (name: string) => Promise<boolean>;
};
export default function NavBarNameForm({ onSave, loading, initialValue }: Props) {
  const [name, setName] = useState(initialValue);
  const [isEditable, setIsEditable] = useState(false);
  const onClick = () => {
    setIsEditable(true);
  };

  const handleSave = async () => {
    if (!loading) {
      const result = await onSave(name);
      setIsEditable(!result);
    }
  };
  const onSubmit = (ev: React.FormEvent<HTMLFormElement>) => {
    ev.preventDefault();
    handleSave();
  };

  if (isEditable) {
    return (
      <ClickAwayListener onClickAway={handleSave}>
        <Box component="form" onSubmit={onSubmit}>
          <TextField
            autoFocus
            disabled={loading}
            value={name}
            onChange={(ev) => setName(ev.target.value)}
            size="small"
            inputProps={{
              sx: { color: 'primary.contrastText', width: 256, ...MARKETBASE_THEME.typography.h6 },
            }}
            name="name"
            sx={{
              '& .MuiOutlinedInput-root input': {
                color: MARKETBASE_THEME.palette.common.white,
                backgroundColor: 'inherit',
              },
              '& .MuiOutlinedInput-root fieldset': {
                borderColor: `${alpha(MARKETBASE_THEME.palette.common.white, 0.25)} !important`,
              },
            }}
          />
        </Box>
      </ClickAwayListener>
    );
  }

  return (
    <Tooltip title="Edit name">
      <Button size="small" onClick={onClick} sx={{ display: 'flex', gap: 1.5, flexDirection: 'row' }}>
        <Typography variant="h6">{name}</Typography>
        <EditOutlined sx={{ fontSize: 16, opacity: 0.8 }} />
      </Button>
    </Tooltip>
  );
}
